/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Fragment, useReducer } from 'react';
import CopyButtons from './CopyButtons';
import SidebarSettings from './SidebarSettings';
import MapSettings from './MapSettings';
import reducer from './reducer';
import mkState from './mkState';
import Context from './Context';

type PropsT = $Shape<{ id: ID }>;

export default (props: PropsT) => {
  // Accept props to seed the initState for testing.
  const [state, dispatch] = useReducer(reducer, mkState().mergeDeep(props));
  const ctx = { state, dispatch };
  const {
    showImagesInListView,
    setShowImagesInListView,
    setSortByLastUpdated,
    sortByLastUpdated,
  } = props;

  return (
    <Context.Provider value={ctx}>
      <Fragment>
        <MapSettings />
        <SidebarSettings
          showImagesInListView={showImagesInListView}
          setShowImagesInListView={setShowImagesInListView}
          sortByLastUpdated={sortByLastUpdated}
          setSortByLastUpdated={setSortByLastUpdated}
        />
        <CopyButtons />
      </Fragment>
    </Context.Provider>
  );
};
